// runtime values from /static/config.js, generated by nginx from the ConfigMap
module.exports = window.__ENV__ || {}



//////////////////
// WEBPACK FOOTER
// ./config/secret.js
// module id = 563
// module chunks = 159